import { createReducer } from 'redux-create-reducer';
import {
  requestCustomersAction,
  receiveCustomersAction,
  addCustomerAction,
} from '../actions/customers';

const initialState = {
  choice: [],
  current: undefined,
  isFetching: false,
};

export const customersReducer = createReducer(initialState, {
  [requestCustomersAction]: state => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveCustomersAction]: (state, action) => {
    return {
      ...state,
      choice: action.payload,
      isFetching: false,
    };
  },
  [addCustomerAction]: (state, action) => {
    const choice = state.choice;
    choice.push(action.payload);
    return {
      ...state,
      isFetching: true,
      choice: choice,
    };
  },
});

export default customersReducer;

export const getCustomers = state => state.customers.choice;
export const getIsFetching = state => state.customers.isFetching;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/reducers/customers.js